<template>
  <v-container>
    <v-card width="400" class="mx-auto mt-5">
      <v-card-title>
        <h4 class="display-1 font-weight-bold mb-3">
          Iniciar Sesión
        </h4>
      </v-card-title>

      <v-card-text @keyup.enter="validate">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            label="Usuario"
            v-model="email"
            id="user"
            name="user"
            type="text"
            :rules="emailRules"
          >
            <v-icon color="#757575" slot="prepend">mdi-account</v-icon>
          </v-text-field>

          <v-text-field
            label="Contraseña"
            v-model="password"
            id="password"
            name="password"
            :type="showpass ? 'text' : 'password'"
            :rules="passwordRules"
            prepend-icon="mdi-lock"
            :append-icon="showpass ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showpass = !showpass"
          >
          </v-text-field>
          <v-card-actions>
           <!-- <v-btn text color="blue darken-4">
              RECUPERAR CLAVE
            </v-btn>-->
            <div class="flex-grow-1"></div>

            <v-btn color="success"
              :loading="loading"
              :disabled="!valid"
              @click="validate"
            >Aceptar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  //name: "LoginLayout",

  props: {
    source: String
  },
  data() {
    return {
      drawer: null,
      valid: true,
      email: "",
      password: "",
      showpass: false,
      passwordRules: [
        v => !!v || "Ingrese contraseña"
        // v => (v && v.length >= 6) || 'Debe tener al menos 6 caracteres' // esta no la esta tomando
      ],
      emailRules: [
        v => !!v || "El e-mail es requerido",
        v => /.+@.+/.test(v) || "Ingrese un e-mail válido"
      ],
      loading: false
    };
  },
  watch: {
    dialog(val) {
      if (!val) return;
      setTimeout(() => (this.dialog = false), 4000);
    }
  },
  created() {
    //this.$store.commit("SET_LAYOUT", "login-layout");
  },

  computed: {
    // ...mapGetters(["loading", "notification", "isLoggedIn"])
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        let email = this.email;
        let password = this.password;
        this.$store
          .dispatch("LOGIN", {
            email: email,
            password: password
          })
          .then((response) => {
            this.$swal({
              title: "Bienvenido!!!",
              icon: "success",
              timer: 1000
            });
            window.location="/edictos"
          })
          .catch(error => {
            console.log(error);
            this.loading = false;
            this.$swal({
              title: "Error",
              text: error.response.data.message,
              icon: "error",
              confirmButtonText: "Aceptar"
            });
          });
      }
    }
  }
};
</script>
